/**
 * Imports
 */
import { createElement } from "commonAssets/lib/createElement.js";
import { appVersion, i18n } from "commonAssets/js/constants";

/**
 * Footer Class
 *
 * A class representing the footer of a website.
 *
 * @class
 */
export class Footer {
    constructor() {
        this.element = this.init();
    }

    /**
     * Initialize the footer.
     * @returns {void}
     */
    init() {
        const currentYear = new Date().getFullYear();
        const div = createElement("div");
        const elements = `
        <div class="text-center py-3">
            <span id="copyright">&copy; ${currentYear}</span>
            <span class="pipe"> | </span>
            <span id="privacy-policy">
                <a href="${i18n.getTranslation("privacy_policy_url")}" 
                    target="_blank" rel="noopener noreferrer" 
                    aria-label="${i18n.getTranslation("privacy_policy")}">
                    ${i18n.getTranslation("privacy_policy")}
                </a>
            </span>
            <span class="pipe"> | </span>
            <span id="version">${i18n.getTranslation("version")} ${appVersion}</span>
        </div>
        `;
        div.innerHTML = elements;
        return div;
    }
}
